import LazyLoad from 'react-lazyload';
import InstantOffersSection from './InstantOffersSection';

const InstantOffersLoader = () => (
    <LazyLoad offset={[250, 250]} height={window.innerHeight}>
        <InstantOffersSection />
    </LazyLoad>
);

export default InstantOffersLoader;
